import {
  SAVE_ADDRESS,
  SAVE_CONTACT,
  MODIFY_ADDRESS,
  SAVE_CAR_INFO,
  UPDATE_MOV,
  RESET_DELIVERY_TYPE,
  UPDATE_PROMOTION,
} from "./actionTypes";
import instance from "./instance";

export const saveAddress = (address) => {
  return async (dispatch, getState) => {
    const newAddress = address;
    delete newAddress.blockError;
    delete newAddress.streetError;
    await dispatch({
      type: SAVE_ADDRESS,
      payload: newAddress,
    });

    const smart_promos = getState().store.store.smart_promos;
    const storeSettings = getState().store?.store?.settings || {};
    const customer = getState().customers;
    const branchDetails = getState().branch;
    const authUser = getState().auth.user;
    const storeCategories = getState().store.store.categories;
    const deliveryTime = getState().deliveryTime;

    await dispatch({
      type: UPDATE_PROMOTION,
      smart_promos: smart_promos,
      customerAddress: customer?.address || {},
      customerBin: customer?.bin || {},
      branchDetails: branchDetails,
      updatePromotionQuantity: false,
      authUser: authUser,
      storeCategories: storeCategories,
      storeSettings,
      deliveryTime,
    });
    try {
      const res = await instance.post("/save_abandoned_cart/", {
        cart: getState().cart,
        customers: getState().customers,
        branch: getState().branch,
        language: getState().store.language,
      });
      if (res.data.success)
        dispatch({ type: "SET_ABANDONED_CART", payload: res.data.id });
    } catch (e) {}
  };
};

export const modifyAddress = (address) => {
  return async (dispatch, getState) => {
    await dispatch({ type: MODIFY_ADDRESS, payload: address });
    const smart_promos = getState().store.store.smart_promos;
    const storeSettings = getState().store?.store?.settings || {};
    const customer = getState().customers;
    const branchDetails = getState().branch;
    const authUser = getState().auth.user;
    const storeCategories = getState().store.store.categories;
    const deliveryTime = getState().deliveryTime;

    await dispatch({
      type: UPDATE_PROMOTION,
      smart_promos: smart_promos,
      customerAddress: customer?.address || {},
      customerBin: customer?.bin || {},
      branchDetails: branchDetails,
      updatePromotionQuantity: false,
      authUser: authUser,
      storeCategories: storeCategories,
      storeSettings,
      deliveryTime,
    });

    if (
      getState().cart.cart.length &&
      (getState().store.store.settings.enable_abandoned_carts ||
        (getState().store.store.settings.enable_sharing_carts_staff &&
          getState().store.store.settings.enable_sharing_carts))
    )
      try {
        const res = await instance.post("/save_abandoned_cart/", {
          cart: getState().cart,
          customers: getState().customers,
          branch: getState().branch,
          language: getState().store.language,
        });
        if (res.data.success)
          dispatch({ type: "SET_ABANDONED_CART", payload: res.data.id });
      } catch (e) {}
  };
};

export const saveCustomerContact = (customer) => {
  return async (dispatch, getState) => {
    const newCustomerContact = {
      name: customer.name,
      phone: customer.phone,
      email: customer.email,
      civilID: customer.civilID,
      birth_date: customer.birthday,
      opt_in_marketing: customer.optInMarketing,
      contact_channel: customer.contactChannel,
    };
    await dispatch({
      type: SAVE_CONTACT,
      payload: newCustomerContact,
    });
    if (
      getState().cart.cart.length &&
      (getState().store.store.settings.enable_abandoned_carts ||
        (getState().store.store.settings.enable_sharing_carts_staff &&
          getState().store.store.settings.enable_sharing_carts))
    )
      try {
        const res = await instance.post("/save_abandoned_cart/", {
          cart: getState().cart,
          customers: getState().customers,
          branch: getState().branch,
          language: getState().store.language,
        });
        if (res.data.success)
          dispatch({ type: "SET_ABANDONED_CART", payload: res.data.id });
      } catch (e) {}
  };
};

export const saveCarInfo = (type, value) => {
  return {
    type: SAVE_CAR_INFO,
    payload: { type: type, value: value },
  };
};

export const resetDeliveryType = () => {
  return {
    type: RESET_DELIVERY_TYPE,
  };
};
